module.exports = __webpack_public_path__ + "img/1147025234.0ba5885f.jpg";